import { useReduxState } from 'hooks';
import { ProgressBar } from 'components/common';
import { CSSProperties } from 'react';

import type { ProgressData } from 'shared-types';

interface Props {
  progressData: ProgressData;
  progressStyle?: CSSProperties;
}

const UserCoursesProgress = ({ progressData, progressStyle }: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="progress">
      {progressData.numberOfCourses ? (
        <div className="progress-bar" style={progressStyle}>
          <ProgressBar
            labels={[
              `${progressData.coursesCompleted} ${messages.commonCompleted}`,
              `${
                progressData.coursesStarted - progressData.coursesCompleted
              } ` + messages.commonStarted,
              `${progressData.numberOfCourses - progressData.coursesStarted} ` +
                messages.commonNotStarted
            ]}
            labelStyle={{ color: theme.textColorLight, marginBottom: 3 }}
            progresses={[
              {
                color: theme.successColor,
                progress:
                  progressData.coursesCompleted / progressData.numberOfCourses
              },
              {
                color: 'rgba(0, 0, 0, 0.4)',
                progress:
                  progressData.coursesStarted / progressData.numberOfCourses
              }
            ]}
          />
        </div>
      ) : (
        <div className="no-courses">{messages.commonNoCourses}</div>
      )}

      <style jsx>{`
        .progress {
          display: inline-block;
        }
        .progress-bar {
          width: 100%;
        }
        .no-courses {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
          line-height: 1;
          width: 100px;
        }
      `}</style>
    </div>
  );
};

export default UserCoursesProgress;
